import { Popover } from "antd";
import PersonEditIcon from "components/svg-icons/person-edit-icon";
import PersonCheckIcon from "components/svg-icons/person-check-icon";
import {
  useMaterialRequestDurationButton,
  type MaterialRequestDurationRow
} from "./use-material-request-duration-button";

export type MaterialRequestDurationButtonProps = {
  material: MaterialRequestDurationRow;
  isFeatureEnabled: boolean;
  canRequest: boolean;
  onClick: (material: MaterialRequestDurationRow) => void;
  /** Archived projects: show the icon greyed out and disabled, no popover. */
  isReadOnly?: boolean;
};

export function MaterialRequestDurationButton({
  material,
  isFeatureEnabled,
  canRequest,
  onClick,
  isReadOnly = false
}: MaterialRequestDurationButtonProps) {
  const {
    shouldRender,
    variant,
    isDisabled,
    buttonClassName,
    testId,
    tooltipContent
  } = useMaterialRequestDurationButton({
    material,
    isFeatureEnabled,
    canRequest
  });

  const Icon = variant === "resend" ? PersonCheckIcon : PersonEditIcon;

  if (isReadOnly && isFeatureEnabled) {
    return (
      <button
        type="button"
        className="ciq-icon-button !p-1.5 text-ciq-gray-400 hover:text-ciq-gray-400"
        disabled
        data-testid={testId}
      >
        <Icon />
      </button>
    );
  }

  if (!shouldRender) {
    return null;
  }

  return (
    <Popover placement="left" content={<div>{tooltipContent}</div>}>
      <div>
        <button
          type="button"
          className={`ciq-icon-button !p-1.5 ${buttonClassName}`}
          onClick={() => {
            onClick(material);
          }}
          disabled={isDisabled}
          data-testid={testId}
        >
          <Icon />
        </button>
      </div>
    </Popover>
  );
}
